export default __webpack_public_path__ + "static/media/confirm.a8df0ef0.svg";